
<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t('search.title')}}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchRoomPolicy"
                  class="form-control"
                  :placeholder="$t('customer.firstname')"
                  v-model="search.name"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchRoomPolicy"
                  type="number"
                  class="form-control"
                  :placeholder="'Số Phòng Ngủ'"
                  v-model="search.num_bedrooms"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchRoomPolicy"
                  type="number"
                  class="form-control"
                  :placeholder="'Người Lớn Tối Đa'"
                  v-model="search.max_adults"
                />
              </div>
            </div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  type="number"
                  v-on:keyup.enter="onSearchRoomPolicy"
                  class="form-control"
                  :placeholder="'Trẻ Em Tối Đa'"
                  v-model="search.max_childs"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchRoomPolicy"
                  type="number"
                  class="form-control"
                  :placeholder="'Số Giường Lớn'"
                  v-model="search.big_bed"
                />
              </div>
              <div class="col-sm-4 col-md-4 col-lg-4">
                <input
                  v-on:keyup.enter="onSearchRoomPolicy"
                  type="number"
                  class="form-control"
                  :placeholder="'Số Giường Nhỏ'"
                  v-model="search.small_bed"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchRoomPolicy"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{$t('search.search_button')}}
                </button>
              </div>
            </div>
          </div>

        </div>

        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>Các Chính Sách</b>
              <lte-button
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-plus"
                @click="showModalAddRoomPolicy($event)"
              >{{$t('user.addnew')}}</lte-button>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-12 table-responsive no-padding">
                  <b-table :items="roomPolicyList" :fields="roomPolicyFields" class="mt-3" outlined>
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template slot="target" slot-scope="row">
                      <a :href="row.item.url" target="_blank" :id="`apartment_reservation_target_${row.item.id}`">{{row.item.target}}</a>
                      <tooltip :text="row.item.url" :target="`#apartment_reservation_target_${row.item.id}`"/>
                    </template>
                    <template slot="actions" slot-scope="row">
                      <template>
                        <div class="btn-group">
                          <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                            <i class="fa fa-fw fa-ellipsis-h"></i>
                          </button>
                          <ul class="dropdown-menu hide-scroll-bar" style="min-width: 50px;max-height: 80px;">
                            <li>
                                <button
                                class="btn btn-primary btn-sm"
                                style="margin-left: 6px;"
                                @click="onEditRoomPolicy(row)"
                                >
                                <i class="glyphicon glyphicon-edit"></i>
                                </button>
                            </li>
                            <li>
                                <button
                                class="btn btn-danger btn-sm"
                                style="margin-left: 6px;"
                                @click="deleteRoomPolicy(row)"
                                >
                                <i class="glyphicon glyphicon-remove"></i>
                                </button>
                            </li>
                          </ul>
                      </div>
                      </template>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Add Room Policy -->
        <div class="modal fade" id="modal-add-room-policy">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{room_policy_id != 0 ? 'Cập Nhật Chính Sách' : 'Thêm Chính Sách'}}</h4>
              </div>
              <div class="modal-body">
                <!-- Row 1 -->
                <div class="row" style="margin: auto; padding-top: 10px; padding-bottom: 10px">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <strong>Tên:</strong>
                        <input class="form-control" type="text" v-model="name" :placeholder="'Nhập Tên'">
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <strong>Số Phòng Ngủ:</strong>
                        <input class="form-control" type="number" v-model="num_bedrooms" placeholder="Nhập Số Phòng Ngủ">
                    </div>
                </div>
                <!-- Row 2 -->
                <div class="row" style="margin: auto; padding-top: 10px; padding-bottom: 10px">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <strong>Người Lớn Tối Đa:</strong>
                        <input class="form-control" type="number" v-model="max_adults" :placeholder="'Nhập Người Lớn Tối Đa'">
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <strong>Trẻ Em Tối Đa:</strong>
                        <input class="form-control" type="number" v-model="max_childs" placeholder="Nhập Trẻ Em Tối Đa">
                    </div>
                </div>
                <!-- Row 3 -->
                <div class="row" style="margin: auto; padding-top: 10px; padding-bottom: 10px">
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <strong>Giường Lớn:</strong>
                        <input class="form-control" type="number" v-model="big_bed" :placeholder="'Nhập Giường Lớn'">
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-6">
                        <strong>Giường Nhỏ:</strong>
                        <input class="form-control" type="number" v-model="small_bed" placeholder="Nhập Giường Nhỏ">
                    </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
                <button type="button" class="btn btn-primary btn-green" @click="onAddNewRoomPolicy">{{$t('common.confirm')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- Modal Confirm Delete Customer Company -->
        <div class="modal fade" id="modal-confirm-delete-room-policy">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{$t('customer.confirm_delete_leaseback_company')}}</h4>
              </div>
              <div class="modal-body">
                <p>{{$t('customer.sure_confirm_delete_leaseback_company')}}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
                <button type="button" class="btn btn-primary btn-green" @click="onDelete">{{$t('common.confirm')}}</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
      </row>
    </div>
  </div>
</template>

<script>
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import { mapGetters, mapActions } from 'vuex';
// import utils from '@/lib/utils'

export default {
  name: "RoomPolicyList",
  data() {
    return {
        roomPolicyList: [],
        roomPolicyFields: [
            { key: 'name', label: 'Tên', sortable: true, class: 'text-center' },
            { key: 'num_bedrooms', label: 'Số Phòng Ngủ', sortable: true, class: 'text-center' },
            { key: 'max_adults', label: 'Người Lớn Tối Đa', sortable: true, class: 'text-center' },
            { key: 'max_childs', label: 'Trẻ Nhỏ Tối Đa', sortable: true, class: 'text-center'},
            { key: 'big_bed', label: 'Giường Lớn', sortable: true, class: 'text-center'},
            { key: 'small_bed', label: 'Giường Nhỏ', sortable: true, class: 'text-center' },
            { key: "actions", label: "common.action", class: 'text-center' }
        ],
        name: '',
        num_bedrooms: '',
        max_adults: '',
        max_childs: '',
        big_bed: '',
        small_bed: '',
        search: {
            name: '',
            num_bedrooms: '',
            max_adults: '',
            max_childs: '',
            big_bed: '',
            small_bed: ''
        },
        room_policy_id: 0,
        isLoading: false
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
        "GET_SNACK_BAR"
    ]),
  },
  methods: {
    ...mapActions([
        "ADD_APARTMENT_LEASEBACK_STAY_POLICY",
        "GET_APARTMENT_LEASEBACK_STAY_POLICY",
        "DELETE_APARTMENT_LEASEBACK_STAY_POLICY",
        "UPDATE_APARTMENT_LEASEBACK_STAY_POLICY",
        "GET_DETAIL_APARTMENT_LEASEBACK_STAY_POLICY",
        "SUCCESS_TOAST",
        "ON_SHOW_TOAST",
        "ERROR_TOAST"
    ]),
    getApartmentLeaseBackStayPolicy: function() {
        this.isLoading = true
        this.GET_APARTMENT_LEASEBACK_STAY_POLICY().then(
            function(res) {
                let data = res
                this.roomPolicyList = []
                for (let i = 0, size = data.length; i < size; i++) {
                    let apartmentLeaseBackStayPolicyObject = {
                        id: data[i].id,
                        name: data[i].name,
                        num_bedrooms: data[i].bedroom_count,
                        max_adults: data[i].max_adults,
                        max_childs: data[i].max_childs,
                        big_bed: data[i].big_bed,
                        small_bed: data[i].small_bed
                    }
                    this.roomPolicyList.push(apartmentLeaseBackStayPolicyObject)
                }
                this.isLoading = false
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
                this.ON_SHOW_TOAST({
                    message: error,
                    styleType: "danger"
                })
            }.bind(this)
        )
    },
    onEditRoomPolicy: function(rowItem) {
        let id = rowItem.item.id
        this.room_policy_id = id
        this.GET_DETAIL_APARTMENT_LEASEBACK_STAY_POLICY({id: id}).then(
            function(res) {
                this.name = res.name,
                this.num_bedrooms = res.bedroom_count,
                this.max_adults = res.max_adults,
                this.max_childs = res.max_childs,
                this.big_bed = res.big_bed,
                this.small_bed = res.small_bed
                $("#modal-add-room-policy").modal("show");
            }.bind(this)
        ).catch(
            function(error) {
                this.ON_SHOW_TOAST({
                    message: error,
                    styleType: "danger"
                })
            }.bind(this)
        )
    },
    onAddNewRoomPolicy: function() {
        let data = {
            name: this.name,
            bedroom_count: this.num_bedrooms,
            max_adults: this.max_adults,
            max_childs: this.max_childs,
            big_bed: this.big_bed,
            small_bed: this.small_bed
        }
        if (this.room_policy_id != 0) {
            this.isLoading = true
            $("#modal-add-room-policy").modal("hide");
            this.UPDATE_APARTMENT_LEASEBACK_STAY_POLICY({id: this.room_policy_id, ...data}).then(
                function(res) {
                    this.isLoading = false
                    this.getApartmentLeaseBackStayPolicy()
                    this.SUCCESS_TOAST()
                }.bind(this)
            ).catch(
                function(error) {
                    this.isLoading = false
                    this.ON_SHOW_TOAST({
                        message: error,
                        styleType: "danger"
                    })
                }.bind(this)
            )
        } else {
            $("#modal-add-room-policy").modal("hide");
            this.ADD_APARTMENT_LEASEBACK_STAY_POLICY(data).then(
                function(res) {
                    this.isLoading = false
                    this.getApartmentLeaseBackStayPolicy()
                    this.SUCCESS_TOAST()
                }.bind(this)
            ).catch(
                function(error) {
                    this.isLoading = false
                    let error_code = error.response.data.error_code
                    if (error_code == "is_exist_bedroom_count") {
                        this.ON_SHOW_TOAST({
                            message: 'Số Phòng Ngủ Đã Tồn Tại',
                            styleType: "danger"
                        })
                    } else {
                        this.ERROR_TOAST()
                    }
                }.bind(this)
            )
        }
    },
    onSearchRoomPolicy: function() {
        let data = {
            params: {
                name: this.search.name,
                bedroom_count: this.search.num_bedrooms,
                max_adults: this.search.max_adults,
                max_childs: this.search.max_childs,
                big_bed: this.search.big_bed,
                small_bed: this.search.small_bed
            }
        }
        this.isLoading = true
        this.GET_APARTMENT_LEASEBACK_STAY_POLICY(data).then(
            function(res) {
                let dataRoomPolicyList = res
                this.roomPolicyList = []
                for (let i = 0, size = dataRoomPolicyList.length; i < size; i++) {
                    let apartmentLeaseBackStayPolicyObject = {
                        id: dataRoomPolicyList[i].id,
                        name: dataRoomPolicyList[i].name,
                        num_bedrooms: dataRoomPolicyList[i].bedroom_count,
                        max_adults: dataRoomPolicyList[i].max_adults,
                        max_childs: dataRoomPolicyList[i].max_childs,
                        big_bed: dataRoomPolicyList[i].big_bed,
                        small_bed: dataRoomPolicyList[i].small_bed
                    }
                    this.roomPolicyList.push(apartmentLeaseBackStayPolicyObject)
                }
                this.isLoading = false
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
            }.bind(this)
        )
    },
    showModalAddRoomPolicy: function() {
        this.room_policy_id = 0
        this.name = ''
        this.num_bedrooms = null
        this.max_adults = null
        this.max_childs = null
        this.big_bed = null
        this.small_bed = null
        $("#modal-add-room-policy").modal("show");
    },
    onDelete:function() {
        this.DELETE_APARTMENT_LEASEBACK_STAY_POLICY({id: this.room_policy_id}).then(
            function(res) {
                this.isLoading = false
                this.getApartmentLeaseBackStayPolicy()
                this.SUCCESS_TOAST()
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
                this.ON_SHOW_TOAST({
                    message: error,
                    styleType: "danger"
                })
            }.bind(this)
        )
    },
    deleteRoomPolicy: function(rowItem) {
        let id = rowItem.item.id
        this.room_policy_id = id
        $("#modal-confirm-delete-room-policy").modal("show")
    }
  },
  mounted() {
      this.getApartmentLeaseBackStayPolicy()
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "lte-button": LTEButton
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apartment/RoomPolicyList.vue